import React, { Component } from 'react';
import { List, Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons';


class CustomerBucketList extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    getBucketType(type) {
        return type.split("_")[1];
    }

    render() {
        const { data, onDeletedClicked } = this.props
        return (
                <List
                    itemLayout="horizontal"
                    dataSource={data}
                    renderItem={(item, ind) => (
                        <List.Item
                            actions={!onDeletedClicked ? null : [
                                <Button
                                color="danger"
                                variant="solid"
                                shape="circle"
                                size="small"
                                icon={<DeleteOutlined />}
                                onClick={() => onDeletedClicked(ind)}
                            />
                            ]}
                        >
                            <List.Item.Meta
                                title={`หมายเลข: ${item.bucket_no}`}
                                description={`ขนาด: ${this.getBucketType(item.bucket_type)}`}
                            />
                        </List.Item>
                    )}
                />
        );
    }
}

export default CustomerBucketList;